// extracted by mini-css-extract-plugin
export default {"rating":"KB-z","numberOfStars":"LB-z","count":"MB-z","barGraphSpacing":"NB-z","barGraph":"OB-z"};